import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, TypeOf, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import {useLocation} from "react-router";

import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";



import LocationFormSelect from "../../../../location/components/location/LocationForm/LocationFormSelect";
import { PrimaryLocation } from "../../../../location/types/models/Location.ts";

import ForestOwnerFormSelect from "../../../../timber/components/forestOwner/ForestOwnerForm/ForestOwnerFormSelect";
import { PrimaryForestOwner } from "../../../../timber/types/models/ForestOwner.ts";
import { t, msg } from "@lingui/core/macro"














export const initialFormStateFn = () => { return {
    
        
        name: "",
        
    
        
        locationId: null,
        
    
        
        forestOwnerId: null,
        
    
} }

export const useLocationFormState = (oldState) => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.forestOwnerId = oldState?.forestOwnerId || PrimaryForestOwner.fromQuery(location.state?.forestOwnerId) || null;
    

    return initialFormState
}

export const formObject = {
    
    
        name:
        string()
        .trim()
        .min(1, msg`Name is required`),
    
    
        locationId:
        string()
                .nanoid(msg`Location is required`)
                .min(1, msg`Location is required`),
    
    
        forestOwnerId:
        string()
                .nanoid(msg`Forest Owner is required`)
                .nullish(),
    
};

export const formSchema = object(formObject);

const TimberStorageUpdateForm = ({watch, prefix = ''})  => {
    return (
        <Container>
            
            
   
   <crudgen.FormInput
       required
       name={ prefix + 'name' }
       aria-label="name"
       data-testid="name"
       label={t`Name`}
       
       type='text'
       
   />
   
   
            
            
   
    
    <LocationFormSelect
        type="dynamicSelect"
        name="locationId"
        label={t`Location`}
        prefix={prefix}
        required={ true }
    />
   
   
   
            
            
   
    
    <ForestOwnerFormSelect
        type="dynamicSelect"
        name="forestOwnerId"
        label={t`Forest Owner`}
        prefix={prefix}
        required={ false }
    />
   
   
   
            
        </Container>
    )
}

export default TimberStorageUpdateForm;
